// extracted by mini-css-extract-plugin
export default {"root":"AgenciesTable_root__o9fla","loader":"AgenciesTable_loader__NEfmh","deactivate":"AgenciesTable_deactivate__z3Sau","activate":"AgenciesTable_activate__ten3O"};